/* Flyball Games — shared homepage-section behavior.
   Every flyball-*.liquid section includes this file. It only runs once per
   page even if included multiple times (guarded below), so each section
   can safely reference it without coordinating with the others. */
(function () {
  "use strict";
  if (window.__fbBaseInit) return;
  window.__fbBaseInit = true;

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.fbPrefersReducedMotion = prefersReducedMotion;

  /* ---------- reveal-on-scroll (targets .fb-reveal in any section) ---------- */
  function initReveal() {
    var revealEls = document.querySelectorAll(".fb-reveal:not(.fb-in)");
    if (!revealEls.length) return;
    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) { el.classList.add("fb-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("fb-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  }
  initReveal();
  document.addEventListener("shopify:section:load", initReveal);

  /* ---------- scoring-ring click ripple on any .fb-btn ---------- */
  if (!prefersReducedMotion) {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".fb-btn");
      if (!btn) return;
      var ring = document.createElement("span");
      ring.className = "fb-click-ring";
      ring.style.left = e.clientX + "px";
      ring.style.top = e.clientY + "px";
      document.body.appendChild(ring);
      ring.addEventListener("animationend", function () { ring.remove(); });
    });
  }

  /* ---------- wishlist heart (persisted in localStorage), shared by any
     section that renders a [data-fb-wishlist] heart button ---------- */
  var WISHLIST_KEY = "flyball_wishlist";
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function initWishlist() {
    var wishlist = getWishlist();
    document.querySelectorAll("[data-fb-wishlist]").forEach(function (btn) {
      if (btn.dataset.fbWishlistBound) return;
      btn.dataset.fbWishlistBound = "true";
      var handle = btn.getAttribute("data-fb-wishlist");
      if (wishlist.indexOf(handle) !== -1) btn.setAttribute("aria-pressed", "true");
      btn.addEventListener("click", function () {
        var pressed = btn.getAttribute("aria-pressed") === "true";
        btn.setAttribute("aria-pressed", String(!pressed));
        var list = getWishlist();
        var idx = list.indexOf(handle);
        if (pressed && idx !== -1) list.splice(idx, 1);
        else if (!pressed && idx === -1) list.push(handle);
        setWishlist(list);
        if (!prefersReducedMotion) {
          btn.classList.remove("fb-is-bouncing");
          void btn.offsetWidth;
          btn.classList.add("fb-is-bouncing");
        }
      });
    });
  }
  initWishlist();
  document.addEventListener("shopify:section:load", initWishlist);

  /* ---------- count-up stat numbers (targets [data-fb-count-to]) ---------- */
  function runCountUp(el) {
    var target = parseFloat(el.getAttribute("data-fb-count-to"));
    var decimals = parseInt(el.getAttribute("data-fb-count-decimals") || "0", 10);
    if (prefersReducedMotion) {
      el.textContent = target.toFixed(decimals);
      return;
    }
    var duration = 900;
    var start = null;
    function tick(ts) {
      if (start === null) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function initCountUp() {
    var countEls = document.querySelectorAll("[data-fb-count-to]:not([data-fb-counted])");
    if (!countEls.length) return;
    if (!("IntersectionObserver" in window)) {
      countEls.forEach(function (el) { el.setAttribute("data-fb-counted", "true"); runCountUp(el); });
      return;
    }
    var countIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.setAttribute("data-fb-counted", "true");
          runCountUp(entry.target);
          countIo.unobserve(entry.target);
        }
      });
    }, { threshold: 0.6 });
    countEls.forEach(function (el) { countIo.observe(el); });
  }
  initCountUp();
  document.addEventListener("shopify:section:load", initCountUp);
})();
